module.exports = __webpack_public_path__ + "components/home-header/static/header-7--large@2x-d6dceba6f6c394192a22b40c98961d17.jpg";